// Exposes method which fetches readiness analytics data from the API.
// @flow
import { authenticatedFetch } from '../request';
import * as AppState from '../../state/reducer/app/appState';
import { updateSearchParams } from '../../state/reducer/analytics/analytics';

export const getMeta = async (): {} => {
    return await authenticatedFetch(`/v5/analytics`);
};

export const fetchAnalytics = async (
    url: string,
    params: {},
    onFail?: Function
) => {
    return await authenticatedFetch(
        url,
        {
            method: 'POST',
            body: JSON.stringify(params)
        },
        onFail
            ? onFail
            : (err: {}) => {
                  AppState.setError(err);
                  updateSearchParams({});
              }
    );
};
